/* eslint-disable no-unused-vars */
class App {
  constructor() {
    this.castID = "3202408036558"
    this.netflixID = "3201907018807"
    this.version = null
    this.preDefinedApps = {
      BLUETOOTH: "org.tizen.ep-hotel-btplayer",
      MIRACAST: "org.tizen.connection-guide-app",
      YOUTUBE: "9Ur5IzDKqV.TizenYouTube",
      BROWSER: "org.tizen.browser",
      USB: "org.volt.mycontents",
      SPOTIFY: "rJeHak5zRg.Spotify"
    }
  }
  _init = async () => {
    this.version = parseInt(navigator.userAgent.match(/Tizen ([\d]+)/)?.pop() || 0)

    try {
      webapis.was?.initializeSIToken("gqWzn3qG4EnEfQmqV9Qlga9DRmBrmeuKpjr7s7yCWhHcd56LVgHN06bwN0UsZqcm")
      // eslint-disable-next-line no-empty
    } catch (error) {}
    return true
  }

  getList = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    tizen.application.getAppsInfo(
      payload => promise.resolve(payload),
      payload => promise.reject(payload.message)
    )
    /* Library Code */

    const res = await promise.done
    if (!res) return res

    const applist = []
    res.forEach(app => applist.push({ key: app.id, value: app.name }))
    const hasNewUsbApp = res.find(item => item.id.includes("com.samsung.tv.mycontents"))
    if (hasNewUsbApp) this.preDefinedApps.USB = hasNewUsbApp.id
    const hasBluetoothApp = res.find(item => item.id.includes("org.tizen.ep-hotel-btplayer"))
    if (!hasBluetoothApp) {
      applist.push({ key: "bluetooth.sideload", value: "bluetooth.sideload" })
      this.preDefinedApps.BLUETOOTH = "bluetooth.sideload"
    }

    this._checkApps(applist)
    return applist
  }
  launch = async app_id => {
    if (!app_id) return false
    let promise = await _$.progress.create(),
      deep_link = null

    if (app_id === "org.tizen.connection-guide-app") {
      promise.resolve()
      deep_link = [new tizen.ApplicationControlData("deeplink", [this.version >= 6 ? "smartphone_screenmirroring_1" : "mobile_screenmirroring_1"])]
    } else if (app_id === "bluetooth.sideload") {
      _$.vue.$sideload("bluetooth", "right")
      return false
    } else {
      if (["com.samsung.tv.mycontents", "org.volt.mycontents"].includes(app_id)) {
        deep_link = await this._getUsbDevice()
        if (!deep_link) return false
      }

      await __.platform.unfocusing()
      _$.vue.$once("applicationUnfocused", () => promise.resolve())
    }

    /* Library Code */
    try {
      const appControl = new tizen.ApplicationControl("http://tizen.org/appcontrol/operation/view", null, null, null, deep_link)
      tizen.application.launchAppControl(
        appControl,
        app_id.toString(),
        () => {},
        payload => promise.reject(payload.message)
      )
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  close = async () => {
    let promise = await _$.progress.create()

    _$.vue.$once("applicationFocusing", () => promise.resolve())

    /* Library Code */
    try {
      tizen.application.launch(
        tizen.application.getCurrentApplication().appInfo.id,
        () => {},
        payload => promise.reject(payload.message)
      )
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  async _getUsbDevice() {
    let app = tizen.application.getCurrentApplication()

    const device = window.storages?.find(storage => storage.type === "EXTERNAL" && storage.state === "MOUNTED")
    if (!device) return null

    const promise = await _$.progress.create()
    tizen.filesystem.resolve(
      device.label,
      dir => {
        promise.resolve([
          new tizen.ApplicationControlData("launch_type", ["mycontents"]),
          new tizen.ApplicationControlData("device_path", [dir.fullPath]),
          new tizen.ApplicationControlData("device_name", [dir.name]),
          new tizen.ApplicationControlData("device_type", ["USB"]),
          new tizen.ApplicationControlData("called_app", [app.appInfo.id])
        ])
      },
      () => promise.reject()
    )
    const res = await promise.done
    return res || null
  }
  async _checkCapability(appID) {
    if (!webapis.was?.getCapability) return false

    const res = webapis.was.getCapability(appID)
    return res === "CAPABILITY_ENABLE"
  }
  async _checkApps(applist) {
    if (!applist?.find(rec => rec.key?.toLowerCase().includes("netflix"))) return this._installApp(this.netflixID)
    return true
  }
  async _installApp(appID) {
    if (!this._checkCapability(appID)) return false

    const listener = {
      oninstallstart: id => {},
      ondownload: (id, progress) => {},
      oninstallation: (id, progress) => {},
      oninstallsuccess: id => __.app.syncAppList(),
      oninstallerror: (id, error) => {},
      onlaunchstarted: id => {},
      onlaunchsuccess: id => {},
      onlauncherror: (id, error) => {}
    }

    webapis.was?.installApp(appID, listener)
    return true
  }
}

export default App
